<template>
    <div class="list-header">
        <div class="title-container">
            <img :src="titleImage" class="title-image" v-if="titleImage" />
        </div>
        <div class="right-icon">
            <img src="../assets/common/list-right-icon.png"/>
        </div>
        <transition name="fade-slide">
            <div class="right-component" v-if="$slots.right">
                <slot name="right"></slot>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'ListHeader2',
    props: {
        titleImage: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
        }
    },
    methods: {
    }
}
</script>

<style scoped lang="less">
.list-header {
    height: 40px;
    padding: 0;
    // background-color: #012F57;
    background: linear-gradient(90deg, rgba(13, 80, 146, 0.5) 0%, rgba(6, 44, 82, 0.5) 100%);
    display: flex;
    flex-direction: row;
    position: relative; /* 添加相对定位，使绝对定位的子元素相对于此容器定位 */

    .title-container {
        width: 280px; /* 统一设置标题容器宽度 */
        height: 40px;
        align-self: center;
        display: flex;
        align-items: center;
        justify-content: center;

        .title-image {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
        }
    }

    .right-component {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 10;
        /* 确保组件不会超出父容器范围 */
        max-width: 40%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .right-icon {
        width: 21px;
        height: 3px;
        position: absolute;
        right: 20px;
        bottom: 4px;
        display: flex;

        img{
            width: 100%;
            height: 100%;
        }
    }
}

/* 动画效果 */
.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: all 0.3s ease;
}

.fade-slide-enter-from {
    opacity: 0;
    transform: translateX(20px);
}

.fade-slide-leave-to {
    opacity: 0;
    transform: translateX(-20px);
}
</style>